import {IMetaTag} from '@core/api/data-access';
import {createActionGroup, props} from '@ngrx/store';

const getMetaTagsEvents = {
	loadMetaTags: props<{
		containDisables?: boolean;
	}>(),
	reloadMetaTags: props<{
		containDisables?: boolean;
	}>(),
	loadMetaTagsSuccess: props<{
		metaTags: IMetaTag[];
	}>(),
	loadMetaTagsFailure: props<{
		error: Error;
	}>(),
};

const addMetaTagEvents = {
	addMetaTag: props<{
		metaTag: IMetaTag;
	}>(),
	addMetaTagSuccess: props<{
		newMetaTag: IMetaTag;
	}>(),
	addMetaTagFailure: props<{
		error: Error;
	}>(),
};

const deleteMetaTagEvents = {
	deleteMetaTag: props<{
		metaTagKey: string;
	}>(),
	deleteMetaTagSuccess: props<{
		metaTagKey: string;
	}>(),
	deleteMetaTagFailure: props<{
		error: Error;
	}>(),
};

const updateMetaTagEvents = {
	updateMetaTag: props<{
		metaTag: IMetaTag;
	}>(),
	updateMetaTagSuccess: props<{
		updatedMetaTag: IMetaTag;
	}>(),
	updateMetaTagFailure: props<{
		error: Error;
	}>(),
};

export const metaTagsActions = createActionGroup({
	source: 'Meta Tags',
	events: {
		...getMetaTagsEvents,
		...addMetaTagEvents,
		...deleteMetaTagEvents,
		...updateMetaTagEvents,
	},
});
